import React, { Component, Fragment } from 'react';
import Header from './Header';
import Terminals from './Terminals';
import LatestOrders from './LatestOrders';
import OpeningHours from './OpeningHours';
import Team from './Team';
import OverviewChart from './OverviewChart';

export default class Establishment extends Component {
  render() {
    return (
      <Fragment>
        <Header />
        <div class="container-fluid mt--7">
          <div class="row">
            <div class="col-xl-8">
              <OverviewChart />
              <LatestOrders />
              <Terminals />
            </div>
            <div class="col-xl-4">
              <OpeningHours />
              <Team />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Establishment/index.js